import React from 'react';
import PropTypes from 'prop-types';
import ReactDataGrid from 'react-data-grid';

const COLUMNS = [
  { key: 'displayName', name: 'Display Name' },
  { key: 'apiName', name: 'API Name' },
  { key: 'type', name: 'Type', width: 100 },
  { key: 'dedupe', name: 'Dedupe Field', width: 130 },
  { key: 'fieldStatus', name: 'Field Status', width: 200 },
];

export default class FieldMetaTable extends React.Component {
  static propTypes = {
    fieldMetas: PropTypes.array.isRequired,
  };

  state = {
    rows: [],
    columns: COLUMNS,
  };

  componentWillMount = () => {
    const { fieldMetas } = this.props;
    this.renderColumns(COLUMNS);
    this.renderRows(fieldMetas.sort(this.initComparer));
  };

  componentWillReceiveProps = nextProps => {
    const { fieldMetas } = nextProps;
    if (fieldMetas.length > 0) {
      this.renderRows(fieldMetas.sort(this.initComparer));
    }
  };

  initComparer = (a, b) => (a.description.toUpperCase() > b.description.toUpperCase() ? 1 : -1);

  rowGetter = i => {
    const { rows } = this.state;
    return rows[i];
  };

  handleRowUpdated = e => {
    // merge updated row with current row and rerender by setting state
    const { rows } = this.state;
    Object.assign(rows[e.rowIdx], e.updated);
    this.setState({
      ...rows,
    });
  };

  handleGridSort = (sortColumn, sortDirection) => {
    const { originalRows, rows } = this.state;
    const comparer = (a, b) => {
      if (sortDirection === 'ASC') {
        if (sortColumn === 'fieldStatus') {
          return a[sortColumn].key > b[sortColumn].key ? 1 : -1;
        }
        return a[sortColumn] > b[sortColumn] ? 1 : -1;
      } else if (sortDirection === 'DESC') {
        if (sortColumn === 'fieldStatus') {
          return a[sortColumn].key < b[sortColumn].key ? 1 : -1;
        }
        return a[sortColumn] < b[sortColumn] ? 1 : -1;
      }
      return null;
    };
    const rowsSorted = sortDirection === 'NONE' ? originalRows.slice() : rows.sort(comparer);
    this.setState({
      rows: rowsSorted,
    });
  };

  renderStatusType = statusType => {
    const installed = statusType === 'OK';
    const icon = installed ? 'check' : 'times';
    const key = installed ? 0 : 1;

    return (
      <span key={key+statusType}>
        <i className={`fa fa-${icon}`} />&nbsp;
        {statusType}
      </span>
    );
  };

  renderDedupeField = dedupeField => {
    const isDedupeField = dedupeField ? 'yes' : 'no';
    return isDedupeField;
  };

  renderColumns = columns => {
    const columnArray = columns.map(c => {
      const copy = Object.assign({}, c);
      if (copy.key !== 'fieldStatus') {
        copy.filterable = true;
      }
      copy.sortable = true;
      copy.resizable = true;
      return copy;
    });

    this.setState({
      columns: columnArray,
    });
  };

  renderRows = fieldMetas => {
    const _rows = [];
    fieldMetas.map((meta, key) => {
      _rows.push({
        key,
        id: key,
        displayName: meta.description,
        apiName: meta.name,
        type: meta.dataType,
        dedupe: this.renderDedupeField(meta.dedupeField),
        fieldStatus: this.renderStatusType(meta.status.statusType),
      });
      return _rows;
    });
    return this.setState({
      rows: _rows,
      originalRows: _rows.slice(),
    });
  };

  render() {
    const { columns, rows } = this.state;
    return (
      <ReactDataGrid
        columns={columns}
        onGridSort={this.handleGridSort}
        rowGetter={this.rowGetter}
        rowsCount={rows.length}
        minHeight={400}
      />
    );
  }
}
